import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from "../app-config/app-config";
import { Observable, BehaviorSubject, Subscription, Subject, ReplaySubject } from 'rxjs';

import { Storage } from '@ionic/storage';

import { PhcApp } from '../../classes/phc-app/phc-app';
import { AlertController, Events, Platform } from 'ionic-angular';
import { Dialogs } from '@ionic-native/dialogs';
import { KioskServiceProvider } from '../kiosk-service/kiosk-service';



/*
  Generated class for the WpProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WpProvider {

  WP_REST_API_BASE = 'https://phc-dev.eventerac.com/wp-json/phc/v2';
  pollingInterval = 5000;
  app: PhcApp = new PhcApp();
  queuedUpdate = false;

  appReady = new ReplaySubject(1);
  firstRun = true;

  currentAlert;

  constructor(private alertCtrl: AlertController,
    public http: HttpClient,
              public appConfig: AppConfigProvider,
              public storage: Storage,
              public events: Events, private platform: Platform, private dialogs: Dialogs, private kiosk: KioskServiceProvider) {
    this.initializeDataService();
    (<any>window).forceClear = this.forceClear;
  }

  forceClear = () => {
      this.storage.set('cache/app', null);
  };

  private initializeDataService() {


    this.storage.get('cache/app').then((appData) => {
      if (appData) {
        this.app.updateAppData(appData);
        this.appReady.next(true);
      } else {
        this.firstRun = true;
      }
      this.pollAndUpdate();
    }).catch(e => this.pollAndUpdate());

  }

  private pollAndUpdate(){
    this.getAppVersion()
      .subscribe(
        (appStatus: any) => {
          if(this.app.id !== appStatus.ID || !this.app.version || (this.app.version && this.app.version < appStatus.version)) {
            console.log('New app version found. Updating...');
            this.getApp()
              .subscribe((appData) => {
                //
                // this.app$.next(this.app);
                if (this.firstRun) {
                  this.firstRun = false;
                  this.app.updateAppData(appData);
                  this.storage.set('cache/app', appData);
                  this.appReady.next(true);
                  setTimeout(_ => this.pollAndUpdate(), this.pollingInterval);
                } else {
                  this.queuedUpdate = true;
                  if (!this.kiosk.isKiosk) {
                    if (this.currentAlert) {
                      return;
                    }
                    this.currentAlert = this.alertCtrl.create({
                      title: 'Update Available',
                      message: 'Tap Update to start using the latest version now.',
                      buttons: [
                        {
                          text: 'Cancel',
                          role: 'cancel',
                          handler: () => {
                            this.currentAlert = null;
                          }
                        },
                        {
                          text: 'Update',
                          handler: () => {
                            window.location.reload();
                            this.currentAlert = null;
                          }
                        }
                      ]
                    });
                    this.currentAlert.present();
                  }
                }
              },
                error => console.log('Error subscribing to app service: ' + error)
              );
          }else{
            // console.log('App version in sync.', this.app.version, appStatus.version);
            setTimeout(_ => this.pollAndUpdate(), this.pollingInterval);
          }
        },
        error => {
          console.log("Error subscribing to polling service: " + error);
          setTimeout(_ => this.pollAndUpdate(), this.pollingInterval);
        }
      );
  }

  private getAppVersion() {
    return this.http.get(`${this.WP_REST_API_BASE}/apps/${this.appConfig.appId}/version`);
  }

  private getApp(){
    return this.http.get(`${this.WP_REST_API_BASE}/apps/${this.appConfig.appId}`);
  }


  postOrder(items, total){
    let body = new FormData();
    body.append('items', JSON.stringify(items));
    body.append('total', total);
    return this.http.post(`${this.WP_REST_API_BASE}/submit-order`, {
        items: JSON.stringify(items),
        total: total
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/wp/wp.ts